import React from 'react'
import './Navbar.css'

const Navbar = () => {
  return (
 
<div>
<div class="topnav">
  <a class="active" href="#home">Home</a>
  <a href="#about">About me</a>
  <a href="#education">Education</a>
  <a href="#skills">Skills</a>
  <a className='contact' href="#contact">Contact</a>
</div>

</div>

  )
}

export default Navbar